import React from 'react'
import * as useragent from 'express-useragent'
import cf from '@/lib/utils/common'
import { getHomePageData } from '../../common/lib/Homepage'
import { getSiteData } from '../../common/lib/auth/authhelpers'
import Theme1Flow from '@/components/ThemeFlowComp/Theme1Flow/Desktop'
import MobileTheme1 from '@/components/ThemeFlowComp/Theme1Flow/Mobile'
import Theme2Flow from '@/components/ThemeFlowComp/Theme2Flow/Desktop'
import MobileTheme2 from '@/components/ThemeFlowComp/Theme2Flow/Mobile'
import Theme4Flow from '@/components/ThemeFlowComp/Theme4Flow/Desktop'
import Theme5Flow from '@/components/ThemeFlowComp/Theme5Flow/Desktop'
import Theme7Flow from '@/components/ThemeFlowComp/Theme7Flow/Desktop'
import Theme8Flow from '@/components/ThemeFlowComp/Theme8Flow/Desktop'
import Theme9Flow from '@/components/ThemeFlowComp/Theme9Flow'
import Theme10Flow from '@/components/ThemeFlowComp/Theme10Flow'
import Theme11FLow from '@/components/ThemeFlowComp/Theme11Flow'
import Theme12Flow from '@/components/ThemeFlowComp/Theme12Flow/Desktop'
import Theme13Flow from '@/components/ThemeFlowComp/Theme13Flow/Desktop'


export default function Home(props) {
  const theme = props?.home?.data?.site?.site_theme

  switch (theme) {
    case 'theme1':
      if (props.isMobile) {
        return <MobileTheme1 {...props} />
      } else {
        return <Theme1Flow {...props} />
      }
      break
    case 'theme2':
      if (props.isMobile) {
        return <MobileTheme2 {...props} />
      } else {
        return <Theme2Flow {...props} />
      }
      break
    case 'theme4':
      return <Theme4Flow {...props} />
      break
    case 'theme5':
      return <Theme5Flow {...props} />
      break
    case 'theme7':
      return <Theme7Flow {...props} />
      break
    case 'theme8':
      return <Theme8Flow {...props} />
      break
    case 'theme9':
      return <Theme9Flow {...props} />
      break
    case 'theme10':
      return <Theme10Flow {...props} />
      break
    case 'theme11':
      return <Theme11FLow {...props} />
    case 'theme12':
      return <Theme12Flow {...props} />
    case 'theme13':
      return <Theme13Flow {...props} />
    default:
      if (props.isMobile) {
        return <MobileTheme1 {...props} />
      } else {
        return <Theme1Flow {...props} />
      }
  }
}

export async function getServerSideProps({ req }) {
  try {


    // for invali url check (404)
    let service_home = req.query.index ? '/' + req.query.index : req.params[0]
    let hostUrl = req.headers.host

    // let hostUrl = "https://zenith-sit.vetravel.io/"
    // let hostUrl = "https://zenith-uat1.vetravel.io/"
    // let hostUrl = "https://www.zenithholidays.com/"
    let checkDomain = 'zenith'
    let findZenith = hostUrl.includes(checkDomain)

    const urls = [
      '/hotels',
      '/flights',
      '/activities',
      '/holidays',
      '/experiences',
      '/offline',
      '/voucher',
      '/visa',
      '/cars',
      '/homestays',
      '/insurances',
      '/tourpackages',
    ]
    const isValidUrl = urls.includes(service_home)


    if (!isValidUrl && findZenith) {

      return {
        notFound: true,
      }
      // return {
      //   redirect: {
      //     permanent: false,
      //     destination: '/holiday/search',
      //   },
      //   props: {},
      // }
    } else if (!isValidUrl) {
      return {
        notFound: true,
      }
    }

    let data = {}
    //await getSiteData(req)
    //let site_id = req?.headers?.site_id

    let homeData = await getHomePageData(req) // home pagedata

    if (!cf.isValueEmpty(homeData) && homeData.status === true && !cf.isValueEmpty(homeData.data)) {
      data = { status: true, data: homeData }
    }
    return {
      props: {
        isMobile: useragent.parse(req.headers['user-agent']).isMobile,
        home: data,
        site_id: data.data.site.id,
        //site_id: site_id,
      },
    }
  } catch (error) {
    return {
      props: {
        isMobile: useragent.parse(req.headers['user-agent']).isMobile,
      },
    }
  }
}
